import styled from 'styled-components';
import Text11 from '@sdk/components/ui/typography/Text11';
import Text14 from '@sdk/components/ui/typography/Text14';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

export const SectionHeader = styled(Text11)`
  color: ${({ theme }) => theme.colors.gray};
  display: block;
  font-weight: 700;
  margin-bottom: 14px;
  opacity: 0.8;
  text-transform: uppercase;
`;

export const LeftColumn = styled(Column)`
  flex-grow: 0;
  width: 260px;
`;

export const RightColumn = styled(Column)`
  flex-grow: 1;
`;

export const FromPersonasContainer = styled(Row)<{ horizontal?: boolean }>`
  flex-wrap: wrap;
  gap: 5%;
  ${({ horizontal }) => (horizontal ? 'margin-bottom: 14px;' : '')}
  row-gap: 14px;

  & > * {
    width: ${({ horizontal }) => (horizontal ? '30%' : '100%')};
  }
`;

export const Warning = styled(Text14)`
  color: ${({ theme }) => theme.colors.danger};
  font-weight: 600;
  margin-top: 10px;
`;

export const DescriptionContainer = styled.div`
  margin-bottom: 25px;
`;
